import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";
import Footer from "./Footer";

/**
 * Shared layout for legal pages (Impressum, Privacy, Contatti).
 * Public — does not require auth. Provides consistent header (logo + back-to-home
 * link + language switcher) and mounts the intermediation footer at the bottom.
 */
export default function LegalLayout({ children, testid, overline, title }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid={testid}>
      <header className="border-b border-slate-100">
        <div className="mx-auto max-w-4xl px-6 py-5 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-slate-950 hover:text-blue-600 transition-colors"
          >
            <div className="w-8 h-8 rounded-lg bg-[#0A0A0B] flex items-center justify-center">
              <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none">
                <path d="M4 20 L12 4 L20 20 L17 20 L15.4 16 L8.6 16 L7 20 Z" fill="#FFFFFF" />
                <path d="M9.7 13 L12 8 L14.3 13 Z" fill="#2563EB" />
              </svg>
            </div>
            <span className="font-heading font-bold text-sm tracking-tight">AUTEXIO</span>
          </Link>
          <div className="flex items-center gap-3">
            <Link
              to="/"
              className="hidden sm:inline-flex items-center gap-1 text-xs font-medium text-slate-500 hover:text-slate-900 transition-colors"
              data-testid="legal-home-link"
            >
              <ArrowLeft className="w-3.5 h-3.5" />
              {t("legal.home_link")}
            </Link>
            <LanguageSwitcher />
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="mx-auto max-w-3xl px-6 py-12 md:py-16">
          {overline && (
            <p className="text-[11px] uppercase tracking-[0.24em] text-blue-600 font-semibold">
              {overline}
            </p>
          )}
          {title && (
            <h1 className="mt-2 font-heading font-bold tracking-tighter text-4xl md:text-5xl text-slate-950">
              {title}
            </h1>
          )}
          <div className="mt-8 text-[15px]">{children}</div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
